import { BnAction } from '../../common/bn-action';

class WorkOrderNotes extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-notes';
    this.successtext = 'Installation notes have been saved.';
    this.errortext = 'Failed to save installation notes.';
    this.submittext = 'Save';
  }

  preRender(action) {
    const field = action.getFieldByName('notes');
    field.type = 'textarea';
    field.title = '';
    field.rows = 7;
    field.placeholder = 'Record any important information about this bin installation';
    action.title = 'Notes';
  }

  async submit() {
    if (!this.entity.hasAction(this.actionname)) {
      // Work orders do not always have an update notes action, ie when they are closed
      return;
    }

    return super.submit();
  }
}

window.customElements.define('work-order-notes', WorkOrderNotes);
